import { useSelector } from 'react-redux';

// Function to get the list of user permissions from Redux
const useUserPermissions = () => {
    const userPermissions = useSelector(state => state.userpermission);
    return userPermissions;
};

// Function to check if a specific permission exists in the array
const useCheckUserPermission = (permissionKey) => {
    const userPermissions = useUserPermissions();
    console.log(userPermissions, "users data from the common permisson file")
    return userPermissions.some(permission => permission.permissionKey === permissionKey);
};

export { useUserPermissions, useCheckUserPermission };